module.exports = __webpack_public_path__ + "static/about-our-sponsors-670440e7d38d96e93eb15817a07371be.jpg";